const ModelType = {
	USER: "user",
	COMPANY: "company",
	VESSEL: "vessel",
	AIRCRAFT: "aircraft"
};
export default ModelType;
